import { Header, Table } from '@mairistem/composants';

import { formatMonetaire } from '@/utils';

interface ModalEncaissementTableFooterProps {
  colspanFooter: number;
  looc?: boolean;
  reste: number;
}

const ModalEncaissementTableFooter = (props: ModalEncaissementTableFooterProps) => {
  const { colspanFooter, looc, reste } = props;

  return (
    <Table.Footer
      style={{
        position: 'sticky',
        bottom: -1,
        background: 'white',
        zIndex: 10,
      }}
    >
      <Table.Row>
        <Table.HeaderCell colspan={colspanFooter} />
        <Table.HeaderCell textAlign="right" style={{ borderLeftColor: 'transparent' }}>
          <Header as="h4">Total à encaisser</Header>
        </Table.HeaderCell>
        <Table.HeaderCell
          textAlign="right"
          style={{
            ...(!looc && { paddingRight: '3.5em' }),
          }}
          colspan={looc ? 1 : 2}
          className="cycle-etat-en-cours"
        >
          <Header as="h3">{formatMonetaire(reste)}</Header>
        </Table.HeaderCell>
      </Table.Row>
    </Table.Footer>
  );
};

export default ModalEncaissementTableFooter;
